import { makeRequest } from "./api";

export const FetchServiceFees = async () => {
  return makeRequest("/api/admin/dashboard/stats");
};
